import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  phoneNumber: yup.string().required(),
});

export function useCreateInboxBlackListEntryMutation(options = {}) {
  return useMutation((dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });
    return http.post(HTTP_ENDPOINTS.inboxBlacklist.createEntry(), {
      phone_number: req.phoneNumber,
    });
  }, options);
}
